require('../../jsy_do_widokow_z_salami/sale/balkon1/row1.js');
require('../../jsy_do_widokow_z_salami/sale/balkon1/row2.js');
require('../../jsy_do_widokow_z_salami/sale/balkon1/row3.js');
require('../../jsy_do_widokow_z_salami/sale/balkon1/row4.js');
require('../../jsy_do_widokow_z_salami/sale/balkon1/row5.js');
require('../../jsy_do_widokow_z_salami/sale/balkon1/row6.js');
require('../../jsy_do_widokow_z_salami/sale/balkon1/row7.js');